import { apiGet, GetReportRequest } from 'api';
import { ReportResponse } from 'types';

export const getOutstandingResponsesReport = (
  request: GetReportRequest
): Promise<ReportResponse> =>
  apiGet<ReportResponse, GetReportRequest>('reports/outstandingresponses', request);
